export class SetTestId {
    constructor(el) {
        this.link = el;
        this.inputs = document.querySelectorAll(".js-set-test-id-input");
        this.selects = document.querySelectorAll(".js-set-test-id-select");
        this.initEvents();
    }

    initEvents() {
        this.link.addEventListener("click", () => {
            const id = this.link.closest(".js-test-list").dataset.id;
            this.inputs.forEach((input) => {
                input.value = id;
            });
            this.selects.forEach((select) => {
                select.dispatchEvent(new CustomEvent("setSelectedByValue", {
                    detail: id
                }));
            });
        });
    }
}

document.querySelectorAll(".js-set-test-id").forEach(elem => new SetTestId(elem));
